const tabs = document.querySelectorAll(".Index_collection_tab");
const tab_details = document.querySelectorAll(".Index_single_collection_detail")

if(window.innerWidth >= 750) {
    tabs.forEach(tab => {
        tab.addEventListener('mouseenter', function() {
            tabs.forEach(t => t.classList.remove("active"));
            this.classList.add("active");
            const data_tab = this.dataset.tab;
            tab_details.forEach(tab_detail => {
                const data_tab_detail = tab_detail.dataset.tabDetail;
                if(data_tab == data_tab_detail) {
                    tab_detail.classList.add("show")
                }
                else {
                    tab_detail.classList.remove("show")
                }
            })
        })
    });
    tabs[0]?.dispatchEvent(new Event("mouseenter"));
}